import { useState, useEffect } from "react";
import ChatbotLauncher from "./ChatbotLauncher";
import VerificationScreen from "./VerificationScreen";
import WelcomeScreen from "./WelcomeScreen";
import ChatScreen from "./ChatScreen";
import "./chatbot.css";

const ChatbotWidget = () => {
  const [open, setOpen] = useState(() => {
    if (typeof window !== "undefined") {
      const savedState = localStorage.getItem("chatbotisOpen");
      return savedState ? JSON.parse(savedState) : false;
    }
    return false;
  });

  const [screen, setScreen] = useState(() => {
    if (typeof window !== "undefined") {
      const savedScreen = localStorage.getItem("chatbot_screen");
      return savedScreen ? JSON.parse(savedScreen) : "verification";
    }
    return "verification";
  });

  const [user, setUser] = useState(() => {
    if (typeof window !== "undefined") {
      const savedUser = localStorage.getItem("chatbot_user");
      return savedUser ? JSON.parse(savedUser) : { name: "", email: "", mobile: "" };
    }
    return { name: "", email: "", mobile: "" };
  });

  // NEW: State to hold the message coming from WelcomeScreen
  const [pendingMessage, setPendingMessage] = useState("");

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("chatbotisOpen", JSON.stringify(open));
    }
  }, [open]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("chatbot_screen", JSON.stringify(screen));
    }
  }, [screen]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("chatbot_user", JSON.stringify(user));
    }
  }, [user]);

  const handleClose = () => {
    setOpen(false);
    setScreen("verification");
    setUser({ name: "", email: "", mobile: "" });
    setPendingMessage(""); // Clear on close

    if (typeof window !== "undefined") {
      localStorage.removeItem("chatbotisOpen");
      localStorage.removeItem("chatbot_screen");
      localStorage.removeItem("chatbot_user");
      localStorage.removeItem("chatbot_messages");
      localStorage.removeItem("chatbot_feedback");
      localStorage.removeItem("chatbot_showOptions");
    }
  };

  return (
    <>
      <ChatbotLauncher onClick={() => setOpen(prev => !prev)} />

      {open && (
        <div className="chatbot-widget">
          {screen === "verification" && (
            <VerificationScreen
              onClose={handleClose}
              setScreen={setScreen}
              setUser={setUser}
            />
          )}

          {screen === "welcome" && (
            <WelcomeScreen
              onClose={handleClose}
              user={user}
              setScreen={setScreen}
              setPendingMessage={setPendingMessage} // PASS SETTER HERE
            />
          )}

          {screen === "chat" && (
            <ChatScreen 
              onClose={handleClose} 
              user={user} 
              setScreen={setScreen}
              pendingMessage={pendingMessage} // PASS VALUE HERE
              setPendingMessage={setPendingMessage} // PASS SETTER HERE TO CLEAR IT
            />
          )}
        </div>
      )}
    </>
  );
};

export default ChatbotWidget;